import { render, staticRenderFns } from "./CombinationList.vue?vue&type=template&id=79211f61"
import script from "./CombinationList.vue?vue&type=script&lang=js"
export * from "./CombinationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports